import { gql } from "graphql-tag";

// Get all pharmacies
export const PHARMACIES_QUERY = gql`
  query GetPharmacies {
    pharmacies {
      id
      name
      address_line_1
      address_line_2
      city
      state
      zipcode
      country_code
      phone_number
      email
      is_active
      latitude
      longitude
      google_maps_url
      npi_number
      created_at
      updated_at
    }
    countries {
      name
      code
    }
  }
`;

// Get a single pharmacy
export const GET_PHARMACY = gql`
  query GetPharmacy($id: ID!) {
    pharmacy(id: $id) {
      id
      name
      address_line_1
      address_line_2
      city
      state
      zipcode
      country_code
      phone_number
      email
      is_active
      is_on_duty
      latitude
      longitude
      opening_hours
      google_maps_url
      npi_number
      created_at
      updated_at
    }
  }
`;

// Search pharmacies with filters and pagination
export const SEARCH_PHARMACIES_QUERY = gql`
  query SearchPharmacies($first: Int!, $after: String, $input: PharmacySearchInput) {
    searchPharmacies(first: $first, after: $after, input: $input) {
      edges {
        node {
          id
          name
          address_line_1
          address_line_2
          city
          state
          zipcode
          country_code
          phone_number
          email
          is_active
          latitude
          longitude
          is_on_duty
          is_open_now
          google_maps_url
          npi_number
          created_at
          updated_at
        }
        cursor
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

// Search pharmacies that have a specific product
export const SEARCH_PHARMACIES_BY_PRODUCT_QUERY = gql`
  query SearchPharmaciesByProduct($first: Int!, $after: String, $input: PharmacyProductSearchInput!) {
    searchPharmaciesByProduct(first: $first, after: $after, input: $input) {
      edges {
        node {
          id
          pharmacy {
            id
            name
            city
            state
            latitude
            longitude
            phone_number
            is_on_duty
            is_open_now
          }
          product {
            id
            name
            cis
            description
          }
          distance_km
        }
        cursor
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;

// Create pharmacy
export const CREATE_PHARMACY_MUTATION = gql`
  mutation CreatePharmacy($input: CreatePharmacyInput!) {
    createPharmacy(input: $input) {
      success
      message
      code
      reason
      data
    }
  }
`;

// Update pharmacy
export const UPDATE_PHARMACY_MUTATION = gql`
  mutation UpdatePharmacy($input: UpdatePharmacyInput!) {
    updatePharmacy(input: $input) {
      id
      success
      code
      reason
    }
  }
`;

// Update pharmacy hours
export const UPDATE_PHARMACY_HOURS_MUTATION = gql`
  mutation UpdatePharmacyHours($input: UpdatePharmacyHoursInput!) {
    updatePharmacyHours(input: $input) {
      id
      success
      message
      code
      reason
      data
    }
  }
`;

// Delete pharmacy
export const DELETE_PHARMACY_MUTATION = gql`
  mutation DeletePharmacy($id: ID!) {
    deletePharmacy(id: $id) {
      id
      success
      code
      reason
    }
  }
`;

// Get pharmacy statistics
export const GET_PHARMACY_STATS = gql`
  query GetPharmacyStats($pharmacyId: ID!, $timeRange: String = "week") {
    pharmacyStats(pharmacyId: $pharmacyId, timeRange: $timeRange) {
      quick_stats {
        pending_requests
        prescriptions
        pharmacy_users
        products_in_stock
      }
      pharmacy_response {
        labels
        datasets {
          label
          data
          background_color
        }
      }
    }
  }
`;
